import { useMutation } from "@apollo/client";
import { EXHIBITION_WORKER_ROLE_UPDATE } from "graphql/mutation/event-gql";
import { errorNotification, successNotification } from "components/request-result";


const useMutationEventWorkerRoleUpdate = () => {
    const [ _setEventWorkerRoleUpdate, { loading } ] = useMutation(
        EXHIBITION_WORKER_ROLE_UPDATE,
        {
            onCompleted(data) {
                const payload = data?.exhibitionWorkerRoleUpdate;

                if (payload)
                {
                    successNotification({
                        title: payload.label,
                        description: payload.message,
                    });
                }
            },
            onError: errorNotification,
        }
    );

    return {
        _setEventWorkerRoleUpdate,
        loadingMutationEventWorkerRoleUpdate: loading,
    };
};

export default useMutationEventWorkerRoleUpdate;
